import script from "./UPeer.vue?vue&type=script&setup=true&lang=js"
export * from "./UPeer.vue?vue&type=script&setup=true&lang=js"

import "./UPeer.vue?vue&type=style&index=0&id=cb5648a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb5648a0"]])

export default __exports__